<template>
  <div class="toasts-stack" :style="{ '--project-drawer-with': drawerWidths.currentPx }">
    <VSonner :offset="toastBottomOffset" expand />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDisplay } from 'vuetify'
import { VSonner } from 'vuetify-sonner'

import { useNavigationDrawer } from '@/common/navigation-drawer/useNavigationDrawer'

export default defineComponent({
  name: 'AppToastsStack',
  components: { VSonner },
  setup() {
    const { drawerWidths } = useNavigationDrawer()
    const { mobile } = useDisplay()

    return {
      drawerWidths,
      mobile,
    }
  },
  computed: {
    toastBottomOffset () {
      return this.mobile ? 16 : 40;
    },
  },
})
</script>

<style lang="scss" scoped>
.toasts-stack {
  :deep(section) {
    ol[data-sonner-toaster] {
      --navigation-drawer-offset: calc(var(--project-drawer-with) / 2);
      left: calc(50% + var(--navigation-drawer-offset));

      div.v-card {
        border-radius: 4px;

        div.v-card-text {
          font-size: 14px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
